import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { Gender, IBookingCarGroup, ILegalEntity, ILocation, IMobilePrefix, InvoiceType, ReactQueryKey } from "../../types";

export interface IResponseGetSubstitution {
        substitutionReason: string[],
        locations: ILocation[],
        raData: {
            pickupDate: string,
            dropoffDate: string,
            dropoffLocation: ILocation,
            carGroup: IBookingCarGroup ,
            ancillaries: {
                code: string,
                mileage: number,
                label: string,
                units: number,
                selected: boolean,
                subtype: string,
                ancillaryCode: any
            }[],
            excDamage: number,
            excFireTheft: number,
            mileageIncluded: string,
            ekm: number,
            currency: string,
            firstDriver: {
                customerId: string,
                name: string,
                surname: string,
                birthDate: string,
                birthNation: string,
                birthPlace: string,
                residenceCountry: string,
                fiscalCode: string,
                email: string,
                mobile: string,
                drivingLicenseNumber: string,
                webCheckIn: boolean,
                gender: Gender | '',
                mobilePrefix: IMobilePrefix | null
            } | null,
            additionalDrivers: {
                customerId: string,
                name: string,
                surname: string,
                email: string,
                webCheckIn: boolean
            }[],
            invoicePerson: {
                customerId: string,
                type: InvoiceType.PERSON,
                name: string,
                surname: string,
                birthDate: string,
                birthNation: string,
                birthPlace: string,
                residenceCountry: string,
                fiscalCode: string,
                email: string,
                mobile: string,
                mobilePrefix: IMobilePrefix | null,
                drivingLicenseNumber: string,
                billingCountry: string | null,
                billingCity: string,
                billingStreetName: string,
                billingStreetNumber: string,
                billingPostalCode: string,
                pec: string,
                billingProvince: string | null
            } | null,
            invoiceCompany: {
                customerId: string,
                type: InvoiceType.COMPANY | InvoiceType.VAT_NUMBER_HOLDER,
                fiscalCode: string,
                email: string,
                billingStreetName: string,
                billingStreetNumber: string,
                billingPostalCode: string,
                billingCity: string,
                billingCountry: string,
                companyName: string,
                invoiceCode: string,
                pec: string,
                vatNumber: string,
                vatNumberCountry: string,
                billingProvince: string | null;
                legalEntity: ILegalEntity | null;
            } | null,
            bookingOwner: {
                customerId: string,
                name: string,
                surname: string,
                birthDate: string,
                birthNation: string,
                birthPlace: string,
                residenceCountry: string,
                fiscalCode: string,
                email: string,
                mobile: string,
                mobilePrefix: IMobilePrefix | null,
                drivingLicenseNumber: string,
            } | null,
            bookingCompanyOwner: {
                customerId: string,
                companyName: string,
                country: string,
                city: string,
                streetName: string,
                streetNumber: string,
                postalCode: string
                email: string,
                pec: string,
                telephone: string,
                mobile: string,
                mobilePrefix: IMobilePrefix | null,
                sdiCode: string,
                vatNumber: string,
                vatNumberCountry: string,
                fiscalCode: string,
                customerCode: string,
                sapId: string,
                productCode: string,
                legalEntity: ILegalEntity | null
            } | null,
    }
}

export const getBookingSubstitution = async (idRentalAgreement: string): Promise<IResponseGetSubstitution> => {
    const response = await axios.get(`/booking/substitution`, {
        params: {idRentalAgreement: idRentalAgreement}
    });
   return response.data;
};

export const useBookingSubstitutionQueryObserver = (id?: string) => {
    return useQuery<IResponseGetSubstitution | null>({
        queryKey: [ReactQueryKey.SubstitutionDataById, id],
        enabled: false
    });
};
